export enum View {
  USERINFO = "LoginForm",
  PASSWORD = "LoginPasswordForm",
}
